import axios from "axios";
import Config from "../globals/Config";
import apiClient from "./apiClient";

export async function sendPOSTRequest(
	route: string,
	params = {},
	responseType: "json" | "blob" | "arraybuffer" = "json"
) {
	try {
		const response = await apiClient.post(
			route,
			{
				...params,
			},
			{ responseType }
		);
		return response.data; // Return the response data
	} catch (error) {
		if (error instanceof Error) {
			console.error("Error making POST request:", error.message);
		} else {
			console.error("Unexpected error:", error);
		}
		throw error;
	}
}

export async function sendGETRequest(route: string, params = {}) {
	try {
		const response = await apiClient.get(route, {
			params,
		});
		return response.data; // Return the response data
	} catch (error) {
		if (error instanceof Error) {
			console.error("Error making GET request:", error.message);
		} else {
			console.error("Unexpected error:", error);
		}
		throw error;
	}
}
